import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Layout from '~components/general/layout';
import Unauthorized from '~components/general/unauthorized';
import AccountsPage from '~components/pages/accounts-page';
import ApplicationsPage from '~components/pages/applications-page';
import ContentPage from '~components/pages/content-page';
import HomePage from '~components/pages/home-page';
import IdentityProvidersPage from '~components/pages/identity-providers-page';
import LoginPage from '~components/pages/login-page';
import SpacesPage from '~components/pages/spaces-page';
import UsersPage from '~components/pages/users-page';
import RequireAuthentication from '~components/util/require-authentication';

export default function Router() {
  return (
    <BrowserRouter basename="/app">
      <Layout>
        <Routes />
      </Layout>
    </BrowserRouter>
  );
}

export const Routes = ({ children }) => {
  return (
    <Switch>
      <Route exact path="/" component={RequireAuthentication(HomePage)} />
      <Route path="/users" component={RequireAuthentication(UsersPage)} />
      <Route path="/accounts" component={RequireAuthentication(AccountsPage)} />
      <Route path="/content" component={RequireAuthentication(ContentPage)} />
      <Route path="/spaces" component={RequireAuthentication(SpacesPage)} />
      <Route path="/applications" component={RequireAuthentication(ApplicationsPage)} />
      <Route path="/identity-providers" component={RequireAuthentication(IdentityProvidersPage)} />
      <Route path="/login" component={LoginPage} />
      <Route path="/unauthorized" component={Unauthorized} />
      {children}
    </Switch>
  );
};

Routes.propTypes = {
  children: PropTypes.node
};

